import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment/moment";
// const leftPanel = "/images/Sticker_black.png";
const bottomPanel = "/images/sticker.jpeg";
const smallCountPerpage = 14;

export const generateQRPDF = async (allData, settingList, size) => {
  try {
    const pdfDoc = new jsPDF({
      orientation: "l", // Landscape
      unit: "pt", // Points
      // format: [594.72, 419.04], // Custom dimensions in points
      format: [132.43, 47.62], // 46.7mm x 16.8mm in points
      compress: true,
    });

    pdfDoc.setFont("helvetica", "bold");

    const pageWidth = pdfDoc.internal.pageSize.width;
    const pageHeight = pdfDoc.internal.pageSize.height;
    const margin = 2; // Margin around the table
    const tableWidth = pageWidth - 2 * margin; // Fit table within page width
    const tableHeight = pageHeight - 2 * margin; // Fit table within page height
    // const fontSize = size === "large" ? 8 : size === "medium" ? 6 : 4;
    const cellPadding = { top: 0.5, left: 1, bottom: 0.5, right: 1 };
    const fontSize = 4;
    const imageRowHeight = tableHeight * 0.35; // 35% of total height for image row
    const dataRowHeight = (tableHeight - imageRowHeight) / 5; // remaining 5 rows

    const leftPanelWidth = 50; // Adjust the left panel image width dynamically
    const initialYPosition = margin; // Starting position on each page
    const marginHorizontal = margin;

    for (let i = 0; i < allData.length; i++) {
      const currentData = allData[i];

      const tableRows = [
        [
          {
            content: "",
            colSpan: 2, // Image spans across 3 columns
            rowSpan: 1,
            styles: { halign: "center", valign: "middle", minCellHeight: imageRowHeight, },
          },
        ],
        [
          // {
          //   content: "",
          //   colSpan: 1,
          //   rowSpan: 5, // rowspan 5 for the image
          //   styles: { halign: "center", valign: "middle", minCellWidth: 30 },
          // },
          {
            content: "Equipment",
            styles: { fontStyle: "bold", halign: "left", valign: "middle",  minCellHeight: dataRowHeight, },
          },
          {
            content: currentData?.datasheet_requestedname
              ? currentData?.datasheet_requestedname
              : currentData?.inst_instrumentName,
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Sl.No./ID No.",
            styles: { fontStyle: "bold", halign: "left", valign: "middle",  minCellHeight: dataRowHeight, },
          },
          {
            content:
              `${
                currentData.srfInstruments_serialNumber &&
                currentData.certificate_DUCID
                  ? `${currentData.srfInstruments_serialNumber} / ${currentData.certificate_DUCID}`
                  : `${currentData.srfInstruments_serialNumber || ""} || ${
                      currentData.certificate_DUCID || ""
                    }`
              }` || "",
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Certificate No.",
            styles: { fontStyle: "bold", halign: "left", valign: "middle",  minCellHeight: dataRowHeight, },
          },
          {
            content:
              `${currentData.certificate_certificateNumber}${
                settingList["amendment"] === "true" &&
                currentData.datasheet_revisionNumber > 0
                  ? `/AMD-${currentData.datasheet_revisionNumber}`
                  : ""
              }` || "",
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Cal. Date",
            styles: { fontStyle: "bold", halign: "left", valign: "middle",  minCellHeight: dataRowHeight, },
          },
          {
            content: currentData.certificate_calibrationDate
              ? moment(currentData.certificate_calibrationDate).format(
                  "DD-MM-YYYY"
                )
              : "",
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Due Date",
            styles: { fontStyle: "bold", halign: "left", valign: "middle",  minCellHeight: dataRowHeight, },
          },
          {
            content: currentData.certificate_nextDueDate
              ? moment(currentData.certificate_nextDueDate).format("DD-MM-YYYY")
              : "",
            styles: { halign: "left", valign: "middle" },
          },
        ],

        // [
        //   {
        //     content: "",
        //     colSpan: 3, // Image spans across 3 columns
        //     rowSpan: 1,
        //     styles: { halign: "center", valign: "middle" },
        //   },
        // ],
      ];

      autoTable(pdfDoc, {
        startY: initialYPosition,
        body: tableRows,
        theme: "grid",
        styles: {
          font: "helvetica",
          fontSize,
          fillColor: false,
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 0.3,
          cellPadding,
        },
        margin: {
          top: margin,
          left: marginHorizontal,
          bottom: margin,
          right: marginHorizontal,
        },
        tableWidth,
        didDrawCell: (data) => {
          const { section } = data;
          if (section === "body") {
            const cell = data.cell;
            const rowIndex = data.row.index;
            const columnIndex = data.column.index;

            // if (columnIndex === 0 && rowIndex < 5) {
            //   const imgSrc = leftPanel;
            //   // const imgWidth = cell.width -5;
            //   // const imgHeight = cell.height -10;
            //   // const x = cell.x + (cell.width - imgWidth) / 2;
            //   // const y = cell.y +5;
            //   const imgWidth = cell.width -20;
            //   const imgHeight = cell.height -110;
            //   const x = cell.x + (cell.width - imgWidth) / 2;
            //   const y = cell.y +80;

            //   // Add the image to the PDF
            //   pdfDoc.addImage(imgSrc, "PNG", x, y, imgWidth, imgHeight);
            // }

            // Check if this is the first row with bottomPanel image
            if (rowIndex === 0 && columnIndex === 0) {
              const imgSrc = bottomPanel;
              const imgWidth = cell.width;   // full cell width
              const imgHeight = cell.height; // full cell height
              const x = cell.x;
              const y = cell.y;

              // Add the bottomPanel image to the PDF
              pdfDoc.addImage(imgSrc, "JPEG", x, y, imgWidth, imgHeight);

              pdfDoc.setLineWidth(0.1);
              pdfDoc.setDrawColor(0, 0, 0);
              pdfDoc.rect(x, y, imgWidth, imgHeight);
            }
          }
        },
        columnStyles: {
          // 0: { cellWidth: (23 / 100) * tableWidth },
          0: { cellWidth: (35 / 100) * tableWidth },
          1: { cellWidth: (65 / 100) * tableWidth },
        },
      });

      // Add new page for the next table
      if (i < allData.length - 1) {
        pdfDoc.addPage();
      }
    }

    // Save or download the PDF
    pdfDoc.save("sticker.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};